import { useEffect } from 'react';

import useFluxibleAction from 'js/lib/fluxibleHooks/useFluxibleAction';
import useFluxibleStore from 'js/lib/fluxibleHooks/useFluxibleStore';
import { useParams } from 'js/lib/useRouter';

import { loadComputedModels } from 'bundles/course-v2/actions/ComputedModelActions';
import CourseStore from 'bundles/in-course-stores/stores/CourseStore';

export const useLoadComputedModels = () => {
  const { courseId } = useFluxibleStore(CourseStore, (store) => ({ courseId: store.getCourseId() }));
  const courseSlug = useParams().courseSlug;

  const executeAction = useFluxibleAction();

  useEffect(() => {
    if (courseId && courseSlug) {
      executeAction(loadComputedModels, { courseSlug, courseId });
    }
  }, [courseId, executeAction, courseSlug]);
};
